import React from 'react';
import { BookOpenIcon, BuildingIcon, GraduationCapIcon, PresentationIcon, ScissorsIcon, SparklesIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { audience } from '../../data/content';
const icons = [ScissorsIcon, GraduationCapIcon, PresentationIcon, BuildingIcon, SparklesIcon, BookOpenIcon];
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-30" data-mp="2869inkfptui8">
      <div className="mx-auto max-w-5xl" data-id="element-31" data-mp="238hv12m3suju">
        <SectionHeading id="audience-heading" eyebrow="Perfect For" title={<>
              Made for Professionals <Accent data-id="element-33" data-mp="2cwzspaz36lj9">Who Teach Hair.</Accent>
            </>} data-id="element-32" data-mp="237g8a0vq6jma" />

        <ul className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-3" role="list" data-id="element-34" data-mp="2qxal4ig1o86j">
          {audience.map((role, index) => {
          const Icon = icons[index];
          return <li key={role} className="flex flex-col items-center rounded-[20px] bg-brand-ivory px-4 py-7 text-center" data-id="element-35" data-mp="2lwd1s2jat83g" data-mpi={index}>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white" data-id="element-36" data-mp="1xa5iynwvl8u1">
                  <Icon className="h-5 w-5 text-brand-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-37" data-mp="2298qcf0bvr56" />
                </span>
                <span className="mt-3 font-display text-[1.25rem] font-bold leading-tight text-brand-charcoal sm:text-[1.35rem]" data-id="element-38" data-mp="26cer574o8q49">
                  {role}
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-39" data-mp="2g7orzrjc2rgg">
          If you already know hairdressing and want a faster, more structured way to prepare and
          deliver your classes — <strong className="font-semibold text-brand-charcoal" data-id="element-40" data-mp="2u1g3v6kjenfc">this system was built for you.</strong>
        </p>
      </div>
    </section>;
}